import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2CompleterModule } from "ng2-completer";
import { AgmCoreModule } from '@agm/core';

import { routing } from './app.routing';

import { ngfModule } from 'angular-file';

import { AuthModule } from './_services/auth.module';
import { AuthService } from './_services/auth.service';
import { PortService } from './_services/port.service';
import { ProjectService } from './_services/project.service';
import { FacilityService } from './_services/facility.service';
import { EmitterService } from './_services/emitter.service';
import { AdminService } from './_services/admin.service';

import { ConfirmDialog, ConfirmDialogService } from './_common/confirm.dialog';

import { AppComponent } from './app.component';
import { AuthGuard } from './_guards/auth.guard';
import { LoginComponent } from './login/login.component';

import { HomeComponent } from './home/home.component';
import { AddPmoComponent, AddPmoDialogComponent } from './home/add-pmo/add-pmo.component';
import { AddPortComponent, AddPortDialogComponent } from './home/add-port/add-port.component';

import { PortComponent } from './port/port.component';
import { AddFacilityDialogComponent } from './port/add-facility/add-facility.component';
import { EditFacilityDialogComponent } from './port/edit-facility/edit-facility.component';
import { AddProjectComponent } from './port/add-project/add-project.component';

import { AdminComponent } from './admin/admin.component';
import { UsersComponent } from './admin/users/users.component';
import { FacilityTypesComponent } from './admin/facility-types/facility-types.component';
import { ProjectTypesComponent } from './admin/project-types/project-types.component';

import {
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatListModule,
    MatExpansionModule,
    MatGridListModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSnackBarModule,
    MatIconModule,
    MatTooltipModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatTabsModule,
    MatTableModule
} from '@angular/material';

import {
    MatMomentDateModule
} from '@angular/material-moment-adapter';

import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgcFloatButtonModule } from 'ngc-float-button';
import { ColorPickerModule } from 'ngx-color-picker';

import { Nl2BrPipe } from "nl2br-pipe";
import { PropertiesPipe } from './_common/properties-pipe';
import { ProjectComponent } from './project/project.component';
import { EditProjectComponent } from './project/edit-project/edit-project.component';
import { PastComponent } from './projects/past/past.component';
import { CurrentComponent } from './projects/current/current.component';
import { FutureComponent } from './projects/future/future.component';
import { EditParticularsDialogComponent } from './projects/edit-particulars/edit-particulars.component';
import { GoogleMapComponent } from './_common/google-map/google-map.component';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        PortComponent,
        AddPmoComponent,
        AddPmoDialogComponent,
        AddPortComponent,
        AddPortDialogComponent,
        AddFacilityDialogComponent,
        EditFacilityDialogComponent,
        AddProjectComponent,

        Nl2BrPipe,
        PropertiesPipe,

        AdminComponent,
        UsersComponent,
        FacilityTypesComponent,
        ProjectTypesComponent,
        ProjectComponent,
        EditProjectComponent,

        ConfirmDialog,

        PastComponent,
        CurrentComponent,
        FutureComponent,
        EditParticularsDialogComponent,
        GoogleMapComponent
    ],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        Ng2CompleterModule,
        BrowserAnimationsModule,
        AuthModule,
        routing,

        ngfModule,

        MatCardModule,
        MatButtonModule,
        MatMenuModule,
        MatToolbarModule,
        MatListModule,
        MatExpansionModule,
        MatGridListModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatSnackBarModule,
        MatIconModule,
        MatTooltipModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatTabsModule,
        MatTableModule,

        NgcFloatButtonModule,
        CurrencyMaskModule,
        ColorPickerModule,

        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBYfsWo8BDbKgWifYGMiviazMrqwqhLNfQ',
            libraries: ["places"]
        })
    ],
    providers: [
        ConfirmDialogService,

        AuthGuard,
        AuthService,
        PortService,
        ProjectService,
        FacilityService,
        EmitterService,
        AdminService
    ],
    bootstrap: [AppComponent],
    entryComponents: [AddPmoDialogComponent, AddPortDialogComponent, AddFacilityDialogComponent, EditFacilityDialogComponent, ConfirmDialog, EditParticularsDialogComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./Angular/app/app.module.ts